import { CssBaseline } from '@mui/material';
import { useRoutes } from 'react-router-dom';
//import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import { MatxTheme } from './components';
import { AuthProvider } from './contexts/JWTAuthContext';
import { SettingsProvider } from './contexts/SettingsContext';
import { AppInitializer } from './contexts/AppInitializer';
import routes from './routes';
import '../fake-db';
import { Provider } from 'react-redux';
import store from '../Store';

const App = () => {
	const content = useRoutes(routes);
	return (
		<Provider store={store}>
			<SettingsProvider>
				<AuthProvider>
					<MatxTheme>
						<CssBaseline />
						<AppInitializer> 
							{content}
						</AppInitializer>
					</MatxTheme>
				</AuthProvider>
			</SettingsProvider>
		</Provider>
	);
};

export default App;
